import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	controlledPurchasesColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Controlled Products, No Verified DEA (PD-16255) — active buyers invoiced a
 * DEA-scheduled item in the last 90 days that hold no verified DEA registration.
 * A verified DEA registered in a state where the account has no location does
 * not count (PD-16547). Rows are the account's DEA licenses (all its licenses
 * when none is a DEA).
 * A state controlled-substance registration is a push, not a ding: it does not
 * clear this list.
 */
export const controlledNoDeaList: ListBuilderList = {
	id: 'compliance-controlled-no-dea',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'No DEA',
	type: 'default',
	active: true,
	sortOrder: 0,
	filterRules: {
		...hideOtherCardFilters(['licenseControlledNoDea']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseControlledNoDea: {
			defaultValue: [
				{ id: 'yes', label: 'Buys controlled product, no verified DEA' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		controlledPurchasesColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
